import React, { useRef, useEffect } from 'react'
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material'
import { useSelector } from 'react-redux'
import Logo from 'static/images/logo-white.svg'

const BrandedPageHeader = ({ children }) => {
  const theme = useTheme()
  const ref = useRef(null)
  const mobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { signedIn } = useSelector(state => state.identity)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const height = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height
        document.documentElement.style.setProperty('--filter-bar-height', height + 'px')
      }
    })

    observer.observe(element)

    return () => {
      document.documentElement.style.setProperty('--filter-bar-height', '0px')
      observer.disconnect()
    }
  }, [])

  return (
    <Box
      ref={ref}
      sx={signedIn ? {
        position: 'fixed',
        top: mobile ? '56px' : 0,
        left: 0,
        right: 0,
        zIndex: 1201,
      } : {}}
    >
      <Box
        sx={{
          width: '100%',
          backgroundColor: theme.palette.background.dark,
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          py: { xs: 2, md: 3 },
        }}
      >
        {signedIn && (
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              position: 'absolute',
              left: 16,
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <Box
              component="img"
              src={Logo}
              alt="MyStethi"
              sx={{ height: 24, width: 24, mr: 1 }}
            />
            <Typography
              sx={{
                color: 'white',
                fontWeight: 600,
                fontSize: '1rem',
                whiteSpace: 'nowrap',
              }}
            >
              MyStethi
            </Typography>
          </Box>
        )}
        <Box sx={{ flex: 1, px: { xs: 2, md: 4 }, ml: { sm: 'var(--drawer-width, 0px)' } }}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}

export default BrandedPageHeader
